"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClayPaginationWithBasicItems = void 0;

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _shared = require("@clayui/shared");

var _react = _interopRequireDefault(require("react"));

var _Pagination = _interopRequireDefault(require("./Pagination"));

var _excluded = ["activePage", "alignmentPosition", "ariaLabels", "disableEllipsis", "disabledPages", "ellipsisBuffer", "hrefConstructor", "onPageChange", "spritemap", "totalPages"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ELLIPSIS_BUFFER = 2;

var ClayPaginationWithBasicItems = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var activePage = _ref.activePage,
      alignmentPosition = _ref.alignmentPosition,
      _ref$ariaLabels = _ref.ariaLabels,
      ariaLabels = _ref$ariaLabels === void 0 ? {
    next: 'Next',
    previous: 'Previous'
  } : _ref$ariaLabels,
      _ref$disableEllipsis = _ref.disableEllipsis,
      disableEllipsis = _ref$disableEllipsis === void 0 ? false : _ref$disableEllipsis,
      _ref$disabledPages = _ref.disabledPages,
      disabledPages = _ref$disabledPages === void 0 ? [] : _ref$disabledPages,
      _ref$ellipsisBuffer = _ref.ellipsisBuffer,
      ellipsisBuffer = _ref$ellipsisBuffer === void 0 ? ELLIPSIS_BUFFER : _ref$ellipsisBuffer,
      hrefConstructor = _ref.hrefConstructor,
      onPageChange = _ref.onPageChange,
      spritemap = _ref.spritemap,
      totalPages = _ref.totalPages,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var previousPage = activePage - 1;
  var previousHref = hrefConstructor && hrefConstructor(previousPage);
  var nextPage = activePage + 1;
  var nextHref = hrefConstructor && hrefConstructor(nextPage);
  var pages = Array(totalPages).fill(0).map(function (item, index) {
    return index + 1;
  });
  return /*#__PURE__*/_react.default.createElement(_Pagination.default, _extends({}, otherProps, {
    ref: ref
  }), /*#__PURE__*/_react.default.createElement(_Pagination.default.Item, {
    "aria-label": ariaLabels.previous,
    disabled: activePage === 1,
    href: previousHref,
    onClick: function onClick() {
      return onPageChange && onPageChange(previousPage);
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "angle-left"
  })), (ellipsisBuffer ? (0, _shared.getEllipsisItems)({
    EllipsisComponent: _Pagination.default.Ellipsis,
    ellipsisProps: {
      alignmentPosition: alignmentPosition,
      disabled: disableEllipsis,
      disabledPages: disabledPages,
      hrefConstructor: hrefConstructor,
      onPageChange: onPageChange
    },
    items: pages
  }, ellipsisBuffer, activePage - 1) : pages).map(function (page, index) {
    return /*#__PURE__*/_react.default.isValidElement(page) ? /*#__PURE__*/_react.default.cloneElement(page, {
      key: "ellipsis".concat(index)
    }) : /*#__PURE__*/_react.default.createElement(_Pagination.default.Item, {
      active: page === activePage,
      disabled: disabledPages.includes(page),
      href: hrefConstructor && hrefConstructor(page),
      key: page,
      onClick: function onClick() {
        return onPageChange && onPageChange(page);
      }
    }, page);
  }), /*#__PURE__*/_react.default.createElement(_Pagination.default.Item, {
    "aria-label": ariaLabels.next,
    disabled: activePage === totalPages,
    href: nextHref,
    onClick: function onClick() {
      return onPageChange && onPageChange(nextPage);
    }
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "angle-right"
  })));
});

exports.ClayPaginationWithBasicItems = ClayPaginationWithBasicItems;
ClayPaginationWithBasicItems.displayName = 'ClayPaginationWithBasicItems';